import { Component, ChangeDetectionStrategy, HostBinding } from '@angular/core';

@Component({
  selector: 'kb-main-grid',
  templateUrl: './main-grid.component.html',
  styleUrls: ['./main-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [],
})
export class MainGridComponent {

  @HostBinding('attr.kb-layout') private layoutType = 'grid';
  @HostBinding('attr.kb-grid-variant') private gridVariant = 'main';

}
